import { DevAuthBanner } from "@/components/dev-auth-banner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./index.css";

document.getElementById("privacy-crawler-link")?.setAttribute("hidden", "");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <TooltipProvider>
        <div className="flex h-dvh flex-col overflow-hidden">
          <DevAuthBanner />
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <App />
          </div>
        </div>
      </TooltipProvider>
    </BrowserRouter>
  </StrictMode>,
);
